import { render, staticRenderFns } from "./OAuthNewUser.vue?vue&type=template&id=4ff500a6"
import script from "./OAuthNewUser.vue?vue&type=script&lang=js"
export * from "./OAuthNewUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports